import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import ProductEditor from '../../editors/productEditor';
import Select from '../../form/Select';
import createForm from "./Form";
import classNames from 'classnames';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {
    BarcodeFormatter, ComponentFormatter,
    CurrencyFormatter, ProductColumn,
    ProductSelect,
    UnitFormatter
} from "../../../utils/formatters";
import {ifCompletedInput} from "../../../utils/other";
import {postData} from "../../../utils/request";
import Icon from "../../form/Icon";
import Modal from "../../layout/Modal";
import SelectorDocuments from "../../form/SelectorGrid/SelectorDocuments";
import UIfx from 'uifx';
import beepErrorMp3 from './../../../sounds/beep-error.mp3';
import beepSuccessMp3 from './../../../sounds/beep-success.mp3';
import CheckBox from "../../form/CheckBox";
import {Tooltip} from "react-tippy";
import ModalEditor from "../ModalEditor";
import {productShortForm} from "./productForm";
import StoreOrderEditor from "../storeorder/storeorderEditor";
import FragmentEditor from "../FragmentEditor";
import DetailsButton from "../../form/DetailsButton";
import ComponentField from "../../form/ComponentField";
import {SelectorGridUnitConvertComponent, UnitConvertComponent} from "src/components/classes/Unit";

const beepError = new UIfx(beepErrorMp3, {});
const beepSuccess = new UIfx(beepSuccessMp3, {});

class storeorderForm extends React.Component {

    state = {
        picked: null,
        updateItem: null,
        filtered: false,
        newProduct: null
    }

    updateItem = async (item) => {
        let actionparams = {
            parentcomponent: this.props.componentConfig.componentname,
            listfield: "items",
            parentid: this.props.values[this.props.componentConfig.idfield]
        };

        const action = item.id ? ((item.qty === undefined || item.qty === null) && parseInt(item.pickedqty || 0) === 0 ? "removeItemsFromList" : "updateItems") : "addItemsToList";

        let items = [item].map((item) => {
            item.storeorder_id = this.props.values[this.props.componentConfig.idfield];
            return item;
        });

        if (action === "addItemsToList") {
            items = items.map((item) => ({data: {...item, qty: item.qty || 0, pickedqty: parseInt(item.pickedqty || 0) + parseInt(item.picked || 0)}}));
        } else if (action === "updateItems") {
            items = items.map((item) => ({data: {...item, qty: item.qty || 0, pickedqty: parseInt(item.pickedqty || 0) + parseInt(item.picked || 0)}}));
        }

        actionparams = {
            ...actionparams,
            action: "componentlist." + action,
            items: items
        };
        await postData(actionparams);
    }

    addPickedItem = async () => {
        const item = {...this.state.picked};
        if (item.picked > 1000) {
            beepError.play();
            return;
        }
        try {
            await this.updateItem({
                id: item.id,
                pickedqty: item.pickedqty,
                product_id: item.product_id,
                qty: item.qty,
                picked: item.picked
            });
            this.setState({
                picked: null,
                updateItem: null
            }, () => {
                this.items.refreshBackground();
                this.newProductOnListIn.hide();
                // szomorú timeout
                setTimeout(() => {
                    this.productPicker.focus();
                }, 50);
                beepSuccess.play();
            });
        } catch (e) {
            beepError.play();
            throw e;
        }
    }

    render() {
        const sortable = true;
        const filterable = true;
        const addItem = this.props.stateTypes.Reserved(this.props.values.state) && this.props.values.ordertype !== undefined && this.props.values.serviceprovider_type === "internal_store";
        const isExternal = ["external_store", "production_store"].indexOf(this.props.values.serviceprovider_type) !== -1;
        const notenumProps = this.props.getFieldProps(!isExternal ? "fullnotenum" : "notenum");
        const notenumField = <TextInput
            name={!isExternal ? "fullnotenum" : "notenum"}
            value={!isExternal ? this.props.values.fullnotenum : this.props.values.notenum}
            label={!this.props.saveButton ? "Szállítólevél szám" : false}
            {...notenumProps}
            disabled={notenumProps.disabled || !isExternal}
            saveChanges={this.props.setFieldValue}
        />;
        let diffFilter = [];
        let compareFields = [["qty","pickedqty"]];
        if (this.props.stateTypes.Received(this.props.values.state) && this.props.values.serviceprovider_type === "internal_store") {
            diffFilter = [{fields: ["qty","promisedqty"], operator: "!<=>"}];
            compareFields = [["qty","promisedqty"]];
        } else if (this.props.stateTypes.Revision(this.props.values.state, "<")) {
            diffFilter = [{
                filters: [
                    {fields: ["qty","pickedqty"], operator: "!<=>"},
                    {field: "pickedqty", operator: "isnull"},
                ],
                operator: "OR"
            }];
        } else if (this.props.stateTypes.Revision(this.props.values.state)) {
            diffFilter = [{
                filters: [
                    {fields: ["pickedqty","checkqty"], operator: "!<=>"},
                    {field: "checkqty", operator: "isnull"},
                ],
                operator: "OR"
            }];
            compareFields = [["pickedqty","checkqty"]];
        } else if (this.props.stateTypes.Completed(this.props.values.state)) {
            diffFilter = [{
                filters: [
                    {fields: ["qty","pickedqty"], operator: "!<=>"},
                    {fields: ["pickedqty","checkqty"], operator: "!<=>"},
                    {fields: ["checkqty","confirmedqty"], operator: "!<=>"},
                ],
                operator: "OR"
            }];
            compareFields = [
                ["qty","pickedqty"],
                ["pickedqty","checkqty"],
                ["checkqty","confirmedqty"]
            ]
        }
        if (!this.state.filtered) {
            diffFilter = [];
        }
        return (
            <Fragment>
                {this.props.closeOrder && <Modal
                    type="default"
                    state="on"
                    header="Eltérés"
                    disabled={this.props.isLoading}
                    buttons={[
                        {
                            text: 'Igen',
                            tabIndex: 1,
                            props: {
                                color: 'danger',
                                focus: true,
                                timeout: 3,
                                disabled: this.props.isLoading
                            },
                            onClick: async () => {
                                await this.props.closeOrderAction();
                            }
                        },
                        {
                            text: 'Mégse',
                            tabIndex: 2,
                            props: {color: 'default', disabled: this.props.isLoading},
                            onClose: true,
                            onClick: async () => {
                                await this.props.cancelCloseOrderAction();
                            }
                        }
                    ]}
                >
                    Eltérés van a kért és a teljesített darabszámok között. Biztos befejezed így?
                </Modal>}
                <Modal
                    ref={(el) => this.newProductOnListIn = el}
                    type="default"
                    header="Eltérés"
                    buttons={[
                        {
                            text: 'Rögzítés',
                            tabIndex: 1,
                            props: {color: 'primary', focus: true},
                            onClick: async () => {
                                await this.addPickedItem();
                            }
                        },
                        {
                            text: 'Mégse',
                            tabIndex: 2,
                            props: {color: 'default'},
                            onClose: true,
                            onClick: () => {
                                this.newProductOnListIn.hide();
                                this.numberInput.focus();
                                this.numberInput.select();
                            }
                        }
                    ]}
                >
                    Listán nem szereplő terméket szeretnél felvenni!
                </Modal>
                <Modal
                    ref={(el) => this.newProductOnListOut = el}
                    type="default"
                    header="Eltérés"
                    buttons={[
                        {
                            text: 'Ok',
                            tabIndex: 2,
                            props: {color: 'primary', focus: true},
                            onClose: true,
                            onClick: () => {
                                this.newProductOnListOut.hide();
                                this.productPicker.focus();
                            }
                        }
                    ]}
                >
                    Ez a tétel nem szerepel a listán!
                </Modal>
                <form onSubmit={this.props.handleSubmit} className="storeorder">
                    <div className="row form-row">
                        <div className="col-md-2">
                            <TextInput
                                name={this.props.componentConfig.idfield}
                                value={this.props.values[this.props.componentConfig.idfield]}
                                label="Kód"
                                role="idfield"
                                {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                            />
                        </div>
                        <div className="col-md-2">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="pid"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                            />
                        </div>
                        <div className="col-md-6">
                            {
                                this.props.saveButton
                                ?
                                    <Fragment>
                                        <label className="control-label">Szállítólevél szám</label>
                                        <div className="input-group">
                                            {notenumField}
                                            <div className="input-group-btn">
                                                {this.props.saveButton}
                                            </div>
                                        </div>
                                    </Fragment>
                                :
                                    notenumField
                            }
                        </div>
                        <div className="col-md-2">
                            <DetailsButton
                                component_type={this.props.values.client_component}
                                component_id={this.props.values.client_component_id}
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-6">
                            <Select
                                label="Partner"
                                name="client.partner"
                                component="partner"
                                objectValue={true}
                                labelKey="name"
                                storeType="remote"
                                value={(this.props.values.client || {}).partner}
                                {...this.props.getFieldProps("client.partner")}
                                disabled={true}
                                saveChanges={this.setFieldValue}
                            />
                        </div>
                        <div className="col-md-6">
                            <TextInput
                                name="client.destination.name"
                                value={((this.props.values.client || {}).destination || {}).name}
                                label="Hova"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("client.destination.name")}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-12">
                            {this.props.values[this.props.componentConfig.idfield] && <Fragment>
                                {addItem && <div className="row form-row">
                                    <div className="col-md-9">
                                        <Select
                                            {...this.props.getFieldProps("productPicker")}
                                            ref={(input) => this.productPicker = input}
                                            label={"Termék"}
                                            component={"StoreOrderItemPool"}
                                            labelKey={"displayname"}
                                            storeType={"remote"}
                                            valueKey={"product_id"}
                                            view={["id","product_id","qty","pickedqty"]}
                                            optionsTemplate={ProductSelect}
                                            parameters={{"storeorder_id": this.props.values[this.props.componentConfig.idfield]}}
                                            autoSelect={true}
                                            searchFormatter={BarcodeFormatter}
                                            placeholder={"Vonalkód vagy cím"}
                                            objectValue={true}
                                            openIfHasOptions={true}
                                            value={this.state.picked}
                                            saveChanges={(field, value) => {
                                                value.picked = 1;
                                                this.setState({picked: value}, () => {
                                                    this.numberInput.focus();
                                                    this.numberInput.select();
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <TextInput
                                            disabled={!this.state.picked}
                                            type="number"
                                            ref={(input) => this.numberInput = input}
                                            name="picked"
                                            value={(this.state.picked || {}).picked}
                                            label="Darabszám"
                                            onKeyDown={(e, field, value) => {
                                                if (ifCompletedInput(e)) {
                                                    this.setState({
                                                        picked: {
                                                            ...this.state.picked,
                                                            picked: value
                                                        }
                                                    }, async () => {
                                                        if (this.state.picked.qty === undefined || this.state.picked.qty === null) {
                                                            this.newProductOnListIn.show();
                                                        } else {
                                                            await this.addPickedItem();
                                                        }
                                                    });
                                                } else if(e.which === 27) {
                                                    this.setState({
                                                        picked: null,
                                                        updateItem: null
                                                    }, () => {
                                                        this.productPicker.focus();
                                                    });
                                                }
                                            }}
                                            {...this.props.getFieldProps("picked")}
                                            saveChanges={(field, value) => {
                                                if (this.state.picked) {
                                                    this.setState({
                                                        picked: {
                                                            ...this.state.picked,
                                                            picked: value
                                                        }
                                                    });
                                                }
                                            }}
                                        />
                                    </div>
                                    {this.state.picked && <div className="col-md-12">
                                        <ProductSelect {...this.state.picked}/>
                                    </div>}
                                </div>}
                                <SelectorGrid
                                    {...this.props.getFieldProps("items")}
                                    ref={(e) => this.items = e}
                                    className={"p-small-table"}
                                    exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                                    view={["id", "name", "qty", "product_id", "unit"]}
                                    filter={diffFilter}
                                    paginatorRight={() => <Tooltip title={!this.state.filtered ? "Csak az eltérések mutatása" : "Mindent mutat"}><CheckBox
                                        onIcon={{lib: "fa", name: "box"}}
                                        offIcon={{lib: "fa", name: "box-open"}}
                                        value={this.state.filtered}
                                        label={false}
                                        saveChanges={(field, value) => {
                                            this.setState({filtered: !!value});
                                        }}
                                    /></Tooltip>}
                                    onItemUpdate={async (item, oldItem, field, rowIndex, {listfieldComponentConfig}) => {
                                        const updateItem = {};
                                        Object.keys(listfieldComponentConfig.fielddefs).map((key) => {
                                            updateItem[key] = item[key];
                                        });
                                        let actionparams = {
                                            parentcomponent: this.props.componentConfig.componentname,
                                            listfield: "items",
                                            parentid: this.props.values[this.props.componentConfig.idfield],
                                            action: "componentlist.updateItems",
                                            items: [updateItem]
                                        };
                                        await postData(actionparams);
                                        return true;
                                    }}
                                    columns={{
                                        "displayname": {
                                            ...ProductColumn("product_id"),
                                            width: 2,
                                        },
                                        "barcode": {
                                            header: 'Vonalkód',
                                            width: 1,
                                            sortable,
                                            filterable
                                        },
                                        "listprice": {
                                            header: 'Ár',
                                            width: 1,
                                            sortable,
                                            filterable,
                                            renderer: CurrencyFormatter,
                                            className: "currency"
                                        },
                                        "qty": {
                                            header: 'Darabszám',
                                            width: 2,
                                            sortable,
                                            filterable,
                                            renderer: SelectorGridUnitConvertComponent,
                                            className: "unit"
                                        },
                                        ...(this.props.stateTypes.Reserved(this.props.values.state, "<=") && this.props.values.serviceprovider_type === "internal_store" ? {
                                            "promisedqty": {
                                                header: "Félretéve",
                                                width: 2,
                                                sortable,
                                                filterable,
                                                aggregation: SelectorGridUnitConvertComponent,
                                                renderer: SelectorGridUnitConvertComponent,
                                                className: "unit",
                                                editor: this.props.stateTypes.Received(this.props.values.state) ?
                                                    (parent) =>
                                                        (props, value) =>
                                                            <TextInput type="number" name="promisedqty" label={false} focus value={value}
                                                                       onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                                                       onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/> : null
                                            },
                                        } : {}),
                                        ...(this.props.stateTypes.Revision(this.props.values.state) || this.props.stateTypes.Completed(this.props.values.state) || this.props.stateTypes.Processed(this.props.values.state) || this.props.stateTypes.Settled(this.props.values.state) ? {
                                            "pickedqty": {
                                                header: this.props.orderTypes.SALES_ORDER(this.props.values.ordertype) ? "Kiszedve" : "Bevételezve",
                                                width: 2,
                                                sortable,
                                                filterable,
                                                aggregation: SelectorGridUnitConvertComponent,
                                                renderer: SelectorGridUnitConvertComponent,
                                                className: "unit",
                                            },
                                        } : {}),
                                        ...(this.props.stateTypes.Revision(this.props.values.state) || this.props.stateTypes.Completed(this.props.values.state) ? {
                                            "checkqty": {
                                                header: "Visszaigazolva",
                                                width: 2,
                                                sortable,
                                                filterable,
                                                aggregation: SelectorGridUnitConvertComponent,
                                                renderer: SelectorGridUnitConvertComponent,
                                                className: "unit",
                                            }
                                        } : {}),
                                        ...(this.props.values.editableqty ? {
                                            [this.props.values.editableqty]: {
                                                header: this.props.values.editableqty === "confirmedqty" ? "Ellenörzés" : (this.props.values.editableqty === "pickedqty" ? (this.props.orderTypes.SALES_ORDER(this.props.values.ordertype) ? "Kiszedve" : "Bevételezve") : (this.props.orderTypes.SALES_ORDER(this.props.values.ordertype) ? "Bevételezve" : "Kiszedve") + " mennyiség"),
                                                width: 2,
                                                sortable,
                                                filterable,
                                                aggregation: SelectorGridUnitConvertComponent,
                                                renderer: this.props.values.editableqty === "pickedqty" ? (value, row) => {
                                                    return <Fragment>{!this.props.getFieldProps("pickedqty").disabled && this.props.stateTypes.Reserved(this.props.values.state) && <a className="btn btn-danger btn-xs pull-right" style={{marginLeft: "5px", marginTop: "-3px"}} onClick={async (e) => {
                                                        e && e.preventDefault();
                                                        const item = {...row};
                                                        item.pickedqty = 0;
                                                        await this.updateItem(item);
                                                        if (this.state.picked && this.state.picked.product_id === item.product_id) {
                                                            this.setState({picked: {...this.state.picked, pickedqty: 0}});
                                                        }
                                                        this.items.refreshBackground();
                                                    }}><Icon lib="fa" name="times-circle" /></a>}<span className="pull-right"><UnitConvertComponent value={value} unit={row.unit} /></span></Fragment>;
                                                } : SelectorGridUnitConvertComponent,
                                                className: "unit",
                                                editor:
                                                    !addItem ? (parent) =>
                                                        (props, value) =>
                                                            <TextInput type="number" name={this.props.values.editableqty} label={false} focus value={value}
                                                                       onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                                                       onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/> : null
                                            },
                                        } : {}),
                                        ...(this.props.stateTypes.Completed(this.props.values.state) ? {
                                            "confirmedqty": {
                                                header: "Ellenörzés",
                                                width: 2,
                                                sortable,
                                                filterable,
                                                aggregation: SelectorGridUnitConvertComponent,
                                                renderer: SelectorGridUnitConvertComponent,
                                                className: "unit",
                                            },
                                        } : {})
                                    }}
                                    rowClassName={(rowData) => {
                                        const classes = {};
                                        if (compareFields.length === 1) {
                                            const check = parseInt(rowData[compareFields[0][1]] || 0);
                                            const qty = parseInt(rowData[compareFields[0][0]] || 0);
                                            if (check > qty) {
                                                classes["p-highlight danger"] = true;
                                            } else if(qty > check) {
                                                classes["p-highlight"] = true;
                                            }
                                        } else {
                                            compareFields.map((fields) => {
                                                const check = parseInt(rowData[fields[0]] || 0);
                                                const qty = parseInt(rowData[fields[1]] || 0);
                                                if (check > qty || check < qty) {
                                                    classes["item-warning"] = true;
                                                }
                                            })
                                        }

                                        return classes;
                                    }}
                                    aggregations={{
                                        fields: {
                                            "qty": {
                                                field: "qty", type: "SUM"
                                            },
                                            "promisedqty": {
                                                field: "promisedqty", type: "SUM"
                                            },
                                            "checkqty": {
                                                field: "checkqty", type: "SUM"
                                            },
                                            "pickedqty": {
                                                field: "pickedqty", type: "SUM"
                                            },
                                            "confirmedqty": {
                                                field: "confirmedqty", type: "SUM"
                                            },
                                            ...(this.props.values.editableqty ? {
                                                [this.props.values.editableqty]: {
                                                    field: this.props.values.editableqty, type: "SUM"
                                                },
                                            } : {}),
                                        }
                                    }}
                                    onLoadCompleted={(response) => {
                                        if (response.aggregations && response.aggregations[0]) {
                                            this.props.setDiff && this.props.setDiff(parseInt(response.aggregations[0].qty || "0") - parseInt(response.aggregations[0].pickedqty || "0"))
                                        } else {

                                        }
                                    }}
                                    listfield="items"
                                    data={this.props.values}
                                    orderBy={{field: "displayname", direction: "ASC"}}
                                    componentConfig={this.props.componentConfig}
                                />
                            </Fragment>}
                        </div>
                    </div>
                    {this.props.values[this.props.componentConfig.idfield] && this.props.stateTypes.Processed(this.props.values.state) && <div className="row form-row">
                        <div className="col-md-12">
                            <label className="control-label">Ismeretlen termékek</label>
                            {this.state.newProduct && <ProductEditor
                                editorContext="UnknownProduct"
                                newProduct={{name: this.state.newProduct.name, listprice: this.state.newProduct.price, barcode: this.state.newProduct.barcode}}
                                onCancelNewProduct={() => this.setState({newProduct: null})}
                                formType={productShortForm}
                                saveForm={() => {
                                    this.setState({newProduct: null});
                                    this.items && this.items.refresh();
                                    this.unknowns && this.unknowns.refresh();
                                }}
                                editor={(props) => <ModalEditor {...props} onClose={() => this.setState({newProduct: null})} state="on"/>}
                                list={() => null}
                                ref={(newProductEditor) => this.newProductEditor = newProductEditor}
                            />}
                            <SelectorGrid
                                {...this.props.getFieldProps("unknowns")}
                                disabled={false}
                                ref={(e) => this.unknowns = e}
                                className={"p-small-table"}
                                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                                component="StoreOrderUnknownProduct"
                                selectionMode="single"
                                filter={[
                                    {
                                        field: "component_type",
                                        value: this.props.componentConfig.componentname
                                    },{
                                        field: "component_id",
                                        value: this.props.values[this.props.componentConfig.idfield]
                                    }
                                ]}
                                selection={this.state.newProduct}
                                onSelectionChange={(selection) => {
                                    //this.setState({newProduct: selection.value});
                                }}
                                columns={{
                                    "name": {
                                        header: 'Megnevezés',
                                        width: 2,
                                        sortable,
                                        filterable
                                    },
                                    "barcode": {
                                        header: 'Vonalkód',
                                        width: 2,
                                        sortable,
                                        filterable
                                    },
                                    "price": {
                                        header: 'Ár',
                                        width: 2,
                                        sortable,
                                        filterable,
                                        className: "currency",
                                        renderer: CurrencyFormatter
                                    },
                                    "qty": {
                                        header: 'Darabszám',
                                        width: 2,
                                        sortable,
                                        filterable,
                                        renderer: SelectorGridUnitConvertComponent,
                                        className: "unit"
                                    }
                                }}
                                aggregations={{
                                    fields: {
                                        "qty": {
                                            field: "qty", type: "SUM"
                                        }
                                    }
                                }}
                                orderBy={{field: "name", direction: "ASC"}}
                            />
                        </div>
                    </div>}
                    <div className="row form-row">
                        <div className="col-md-12">
                            {
                                this.props.componentConfig.fielddefs.documents
                                && this.props.componentConfig.fielddefs.documents.type === "componentlist"
                                && <Fragment>
                                    <label className="control-label">Dokumentumok</label>
                                    <SelectorGrid
                                        {...this.props.getFieldProps("documents")}
                                        disabled={false}
                                        componentConfig={this.props.componentConfig}
                                        className={"p-small-table"}
                                        view={["filename", "path"]}
                                        type={SelectorDocuments}
                                        pageSize={0}
                                        listfield={"documents"}
                                        data={this.props.values}
                                        orderBy={{field: "filename", direction: "ASC"}}
                                    />
                                   </Fragment>
                            }
                        </div>
                    </div>
                </form>
            </Fragment>
        );
    }
}

export default createForm(storeorderForm);
